module.exports = __webpack_public_path__ + "static/media/sketch_02.331c4b67.png";